import { render, staticRenderFns } from "./order-view-notification.vue?vue&type=template&id=19826610&"
import script from "./order-view-notification.ts?vue&type=script&lang=ts&"
export * from "./order-view-notification.ts?vue&type=script&lang=ts&"
import style0 from "./order-view-notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports